<!-- 入厂不合格 详情 验收记录单 页面 -->
<template>
  <h-inspection-page :title="h_i18n('8995232b8db82519b843a940a48a5829')" class="intoFactoryUnqualifiedDetailPage_style" @inspection-update="inspectionUpdate" v-loading="data.loading" :empty-text="h_i18n('17c0437d386a5811042f362675b56ffc')">
    <inspection-header :title="h_i18n('ae9b9e9cea1400387a36eb46740cf07c')" title-height="80px">
      <template #title>
        <h-p align="left" style="font-weight: 600;" :title="h_i18n('4850ea222f13bd23bec1cdace19cb633')">00074001AC98</h-p>
        <h-p align="left" class="code_number_style" :title="h_i18n('c515f3385e7740c52e22eefc10b62f2b')">
          <el-tooltip effect="light" :content="data.getData.sendGoodsNo" placement="top-start">
            <span>{{ data.getData.sendGoodsNo }}</span>
          </el-tooltip></h-p>
      </template>
      <template #body>
        <tr>
          <h-td :title="h_i18n('f1edca9f040d256cee01ef89fa5499f0')">{{ data.getData.mtlNo }}</h-td>
          <h-td :title="h_i18n('901fcadda8a5683e7a83a0c811ff4382')">{{ data.getData.mtlName }}</h-td>
          <h-td :title="h_i18n('7d0d9d5a6a61aa1f3037e2514fe3a18d')">{{ data.getData.sybName }}</h-td>
        </tr>
        <tr v-if="data.type === 'VMI'">
          <h-td :title="h_i18n('1b7ecd2bdbd8a1a112dead57724f06df')">{{ data.getData.supplyCode }}</h-td>
          <h-td :title="h_i18n('9190cc22c9ba377113bc54ac51013a0b')" colspan="3">{{ data.getData.supplyName }}</h-td>
        </tr>
        <tr v-else>
          <h-td :title="h_i18n('1b7ecd2bdbd8a1a112dead57724f06df')">{{ data.getData.supplyCode }}</h-td>
          <h-td :title="h_i18n('9190cc22c9ba377113bc54ac51013a0b')">{{ data.getData.supplyName }}</h-td>
          <h-td :title="h_i18n('73ad4acf69901d02a25654178709e679')">{{ data.getData.supplyType }}</h-td>
        </tr>
        <tr>
          <h-td :title="h_i18n('d663cf0406368e8486d4a7d107f96d6b')">{{ data.getData.checkStyleName }}</h-td>
          <h-td :title="h_i18n('86b9bda0a87ded3daf94664df6f43b49')">{{ data.getData.sapMarkName }}</h-td>
          <h-td :title="h_i18n('33ac341a8748c430f721aa43dcf9f3b6')">{{ data.getData.materielCategoryName }}</h-td>
        </tr>
        <tr class="redTitle_style">
          <h-td colspan="5" :title="h_i18n('f8178ce31afe953ee92fc051676da154')">{{ data.getData.checkReason }}</h-td>
        </tr>
      </template>

      
    </inspection-header>
    <div class="wrap_style">
      <div class="table-box table-box-bordered table-padding-left" :style="{'--oneWeight':data.oneWeight}">
        <table width="0" border="0" cellspacing="0" cellpadding="0" style="min-width:1500px" class="table-middle" ref="sczRef">

          <tr>
            <th rowspan="4" width="3%">{{ h_i18n('faaadc447b1c2b1adc920d9c9aedcc25') }}</th>
            <th rowspan="2" width="6%">{{ h_i18n('222c0f1a6341c9df01ca58fc982db93b') }}</th>
            <th rowspan="2" width="6%" >{{ h_i18n('f4aadbe7c1febb0b5cd8c1a9164319e3') }}</th>

            <th rowspan="2" width="25%">{{ h_i18n('53285596305f4f7508724d282ed9dcdc') }}</th>

            <th rowspan="2" width="6%">{{ h_i18n('bd9d32f9b63c551e252decdf8b3c854b') }}</th>
            <th rowspan="2" width="6%">{{ h_i18n('9e23b61ce24cfada6fea1cdc2277976c') }}</th>

            <th colspan="2" width="6%">{{ h_i18n('9ad6f829b961e347a0c8233ea1e57e42') }}</th>
            <th colspan="8" width="13%">{{ h_i18n('c5fb490f9763ca6e6320049b20e23a92') }}</th>

            <th rowspan="2" width="4%">{{ h_i18n('4626e7457839719f5fa1b08526e5e3fd') }}</th>

            <th rowspan="2" width="6%">{{ h_i18n('0cf684d33849528278363c0e3991cb82') }}</th>

            <th rowspan="2" width="4%">AQL</th>

            <th colspan="2" width="6%">{{ h_i18n('df011658c33f610e9b9d3302909a7f2b') }}</th>
            <th rowspan="2" width="4%">{{ h_i18n('f2996845b6bf0a07fe26f74f35e42ebe') }}</th>
            <th rowspan="2" width="6%">{{ h_i18n('0e8a40b9150d5f2aebbd153153f92bc1') }}</th>
          </tr>

          <tr height="10" >
            <td>Ac</td>
            <td>Re</td>
            <td>1</td>
            <td>2</td>
            <td>3</td>
            <td>4</td>
            <td>5</td>
            <td>6</td>
            <td>7</td>
            <td>8</td>
            <td>min</td>
            <td>max</td>
          </tr>
          <tbody>
            <tr v-for="(item, index) in data.testRecordCheckList" :key="index">
              <td width="3%" >{{index+1}}</td>
              <td width="6%" class=" text-overflow">{{item.itemName}}</td>
              <td width="6%" class="text-overflow">{{item.codeName}}</td>
              <td width="25%" style="text-align:left;" class="text-overflow">{{item.remark}}</td>
              <td width="6%">{{item.dataType}}</td>
              <td width="6%">{{item.patternNo}}</td>
              <td>{{item.acDeterminant}}</td>
              <td>{{item.reDeterminant}}</td>
              <td colspan="8" class="noPadding_style">
                <div v-if="item.dataType == h_i18n('f96c63cc7406f89d0e2fe171d4d7c3b6') && item.factTestValue"
                  class="big_input_style"
                >{{item.factTestValue}}</div>
                <div v-else-if="item.dataType == h_i18n('c5a52c27d6d73e6050d740ddade79fd4') && item.factTestValue && item.factTestValue.split(',').length > 0">
                  <div v-for="temp in item.factTestValue.split(',')"
                    class="small_input_style"
                  >{{ temp }}</div>
                </div>
              </td>
              <td>{{item.importancePropertyName}}</td>
              <td>{{item.deterLevelNum}}</td>
              <td>{{item.aqlProperty}}</td>
              <td class="text-overflow">{{item.testareaMin}}</td>
              <td class="text-overflow">{{item.testareaMax}}</td>
              <td>{{item.unit}}</td>
              <td>
                <span v-if="item.singleDeterminant == 'P'" :style="{ color: '#165dff' }">{{ h_i18n('86f720320b77bb62311f0a4811db04fe') }}</span>
                <span v-if="item.singleDeterminant == 'F'" :style="{ color: 'red' }">{{ h_i18n('6e5a122013138ad189517d5d0a1c0891') }}</span>
                <span v-if="item.singleDeterminant == 'N'" :style="{ color: '#1d2129' }">{{ h_i18n('b51d166ef0e0f0df4aca8571884ef099') }}</span>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <div class="table-box table-box-bordered table-padding-left table-box2" :style="{'--imageWeight':data.imageWeight}">
      <table width="0" border="0" cellspacing="0" cellpadding="0">
        <tbody>
        <tr>
          <td colspan="23" style="text-align:left;">
            <span>{{ h_i18n('ecb23fa395b8579293fbf94f09583394') }}{{ data.getData.sendGoodsNo }}</span>&nbsp;&nbsp;&nbsp;&nbsp;
            <span>{{ h_i18n('c6bbf42cfa95cbd26917ac5dbe0adf00') }}{{ data.getData.patternAmount }}</span>
          </td>
        </tr>
        <tr>
          <td rowspan="2" style="vertical-align: middle;">{{ h_i18n('991d5e29be322940c40a0b01e5ddcb98') }}</td>
          <td colspan="20" style="text-align: left;">{{ h_i18n('72695a16ba065750755b494c7a389dc5') }}<span v-if="data.getData.testConclusion == 'P'" :style="{ color: 'blue' }">{{ h_i18n('86f720320b77bb62311f0a4811db04fe') }}</span>
            <span v-if="data.getData.testConclusion == 'F'" :style="{ color: 'red' }">{{ h_i18n('6e5a122013138ad189517d5d0a1c0891') }}</span>
          </td>
        </tr>

        <tr>
          <td colspan="20" style="text-align: left;">
            <!-- <span style="margin-right: 50px;">测试人：{{ data.getData.iqcManagerName }}</span> -->
            <span>{{ h_i18n('11b89350eb7a3cca5223829fb7fbba66') }}{{ time(data.getData.testCompleteDay,6) }}</span>
          </td>
        </tr>

        <tr>
          <td colspan="1" width="10%">{{ h_i18n('6ef477cad8b23c2a86d2ea58ea3fbe23') }}</td>
          <td colspan="19" style="text-align:left">
            <div class="default-body-image-list" v-if="data.fileUuidSizeList.length > 0">
              <div class="default-body-image" v-for="(item,i) in data.fileUuidSizeList" :key="i">
                <div class="image_text_style">
                  <el-image v-monitor-src class="default-body-image-icon" :src='item'
                   :alt="data.getData.fileNameSize?.split(',')[i]"
                   @click.stop="lookPicture(data.getData.fileUuidSize?.split(',')[i], data.getData.fileNameSize?.split(',')[i])"/>
                  <div class="default-body-image-name"
                    @click="downLoadFile(data.getData.fileUuidSize?.split(',')[i], data.getData.fileNameSize?.split(',')[i])">
                    {{ data.getData.fileNameSize?.split(',')[i] }}
                  </div>
                </div>
              </div>
            </div>
          </td>
        </tr>
        <tr>
          <td colspan="1" width="12%">{{ h_i18n('cdecfdba43a97982759d42b593228e76') }}</td>
          <td colspan="19" class="file_td_style">
            <div style="text-align:left;">
              <div v-if="data.getData.fileUuidThirdReport" class="file_content_style">
                <span v-for="(item,i) in data.getData.fileUuidThirdReport.split(',')"
                @click="downLoadFile(item,data.getData.fileNameThirdReport.split(',')[i])">
                  {{ data.getData.fileNameThirdReport.split(',')[i] }}
                </span>
              </div>
              <!-- <span @click="downLoadFile(data.getData.fileUuidThirdReport,data.getData.fileNameThirdReport)"
                style="color: #165dff; cursor: pointer">{{ data.getData.fileNameThirdReport }}</span> -->
            </div>
          </td>
        </tr>
        <tr class="noBorder_tr_style">
          <td colspan="21" style="text-align: center;" class="noBorder_td_style">
            <h-button size="smaill" @click="$router.back()">{{ h_i18n('b15d91274e9fc68608c609999e0413fa') }}</h-button>
          </td>
        </tr>
        </tbody>
      </table>
    </div>

    </div>

  </h-inspection-page>
  <h-dialog :show="data.lookPic" :title="h_i18n('0576a9149ec01e289e8e1eeb4f6c2b92')" width="80%" @close="data.lookPic = false , data.lookPicUrl = ''" class="dialog_style">
    <div style="padding: 0 0;text-align: center">
      <div>
        <img v-monitor-src :src="data.lookPicUrl" class="lookImg_style"/>
      </div>
    </div>
  </h-dialog>
</template>

<script setup>
//Automatic script writing.
import h_i18n from '@/utils/Internationalization';

  import { reactive, getCurrentInstance, onMounted, ref, nextTick, onActivated, onDeactivated } from 'vue';
  import { useRoute, useRouter } from 'vue-router';
  import axios from 'axios';
  const { proxy, ctx } = getCurrentInstance();
  const route = useRoute();
  const sczRef = ref(null)

  const data = reactive({
    sendGoodsNo:null,
    mtlNo:null,
    goodsSort:null,
    uuidFail:null,
    checkTime:null,
    source:null,
    type:null,
    testRecordCheckList:[],
    getData:{},
    oneWeight:24,
    imageWeight:100,
    loading:false,
    lookPic:false,
    lookPicUrl:null,
    fileUuidSizeList:[], // 处理后的不合格图片列表
  })
  // 下载附件
  const downLoadFile = (uuid, fileName) => {
    let uid = ''
    if(uuid && uuid.includes('http')){
      if(uuid.includes('/fileDownload/downloadFromOSS')){
        uid = '/base/fileDownload/downloadFile?filePath=' + uuid.split('filePath=')[1]
        // handleClickComplain(uid,fileName)
        // return
        if(fileName.lastIndexOf(".") === -1){
          fileName += ('.'+uid.substring(uid.lastIndexOf(".") + 1))
        }
      }else{
        uid = uuid
      }
    }else{
      uid = '/base/fileDownload/downloadFile?filePath='+uuid
    }
    proxy.startLoading(h_i18n('8ffe8dae6d15a5be77490834bff8d28b'))
    proxy.httpFile({
        method: 'get',
        url: uid,
        headers: { 'content-type': 'application/json' },
    }, fileName).then(res=>{
      console.log(res)
    }).catch(err=>{
      proxy.warning(h_i18n('65e200d30c86a93c46dcafaa151028f5'))
    }).finally(()=>{
      proxy.closeLoading()
    })
  }
  const lookPicture = (uuid,fileName) => {
    let suffix = uuid.substring(uuid.lastIndexOf(".") + 1)
    let photoSuffix = ["jpeg", "jpg", "png", "webp", "gif"]
    if (photoSuffix.includes(suffix.toLowerCase())) {
      // 打开查看
      data.lookPic = true
      if(uuid.includes('http')){
        data.lookPicUrl = uuid
      }else{
        data.lookPicUrl = proxy.$filePathSplicing(uuid, 'img')
      }
    }else{
      downLoadFile(uuid, fileName)
    }
  }
  // 查询内容
  const searchTestRecordCheck=()=>{
    data.loading = true
    proxy.$http({
      method: 'get',
      url: `/base/batchPlanTestConclusionFail/batchRecordDetailNew?sendGoodsNos=${data.sendGoodsNo}&mtlNo=${data.mtlNo}&goodsSorts=${data.goodsSort}&uuidFail=${data.uuidFail}&checkTime=${data.checkTime}&source=${data.source}`,
    }).then(res=>{
      // console.log('res=>', res.data.batchCheckTableDetailList)
      data.testRecordCheckList = res.data.batchCheckTableDetailList
      data.getData = res.data.batchRecordTable || {
        sendGoodsNo: data.sendGoodsNo,
        // mtlNo: data.mtlNo,
      }
      if(!res.data.batchCheckTableDetailList && !res.data.batchRecordTable){
        proxy.warning(h_i18n('615e3012db5814b4231d439170cd9500'))
        return
      }
      // 处理不合格图片列表
      if (data.getData.fileUuidSize) {
        data.fileUuidSizeList = data.getData.fileUuidSize.split(',').map(item => {
          return proxy.$filePathSplicing(item, 'img')
        })
        console.log('sssssssssssss',data.fileUuidSizeList)
      }
      let testimportancePropertyList = res.data.importancePropertyList ? res.data.importancePropertyList : [] // 重要性分类表
      let testitemCodeList = res.data.itemCodeList ? res.data.itemCodeList : []  // 检验类别分类表
      let checkLevelList = res.data.checkLevelList ? res.data.checkLevelList : [] // 判定水平分类表
      data.testRecordCheckList.forEach(item => {
        // 补充重要性 & 检验类别 & 检查水平
        testimportancePropertyList.forEach(temp => {
          if (item.importanceProperty == temp.valueId) {
            item.importancePropertyName = temp.valueName
          }
        })
        testitemCodeList.forEach(element => {
          if (item.itemCode == element.valueId) {
            item.codeName = element.valueName
          }
        })
        checkLevelList.forEach(e => {
          if (item.checkLevel == e.valueId) {
            item.deterLevelNum = e.valueName
          }
        })
      })

      console.log(data.testRecordCheckList)
    }).catch(err=>{
      console.log('err',err)
    }).finally(()=>{
      data.loading = false
      proxy.changeHeight()
    })
  }

  const searchTestRecordCheckVMI = ()=>{
    data.loading = true
    proxy.$http({
      method: 'get',
      url: `/base/examinePlan/getCheckInfoDetail?sendGoodsNo=${data.sendGoodsNo}`
    }).then(res=>{
      console.log(res,"查询vmi详情")
      data.getData = res.data.data.checkTableDTO
      // 其他见证资料
      data.getData.fileUuidThirdReport = data.getData.otherFileUrl
      data.getData.fileNameThirdReport = data.getData.otherFileName
      // 不合格图片
      data.getData.fileUuidSize = data.getData.unquanlifyPicUrl
      data.getData.fileNameSize = data.getData.unquanlifyPicName
      // 处理不合格图片列表
      if (data.getData.fileUuidSize) {
        data.fileUuidSizeList = data.getData.fileUuidSize.split(',').map(item => {
          return proxy.$filePathSplicing(item, 'img')
        })
      }
      // 检验类别 , 检查水平 , 结果判定
      data.testRecordCheckList = res.data.data.checkTableDetails
      data.testRecordCheckList.forEach(item=>{
        item.singleDeterminant = item.singleDeterminant ? item.singleDeterminant : "P"
        item.deterLevelNum = item.checkLevelName ? item.checkLevelName : ''
        item.codeName = item.itemCodeName ? item.itemCodeName : ''
      })
      // 测试结果
      if (data.testRecordCheckList.some(v => v.singleDeterminant === "F")) {
        data.getData.testConclusion = "F"
      } else {
        data.getData.testConclusion = "P"
      }
    }).catch(err=>{
      console.log('err',err)
    }).finally(()=>{
      data.loading = false
      proxy.changeHeight()
    })
  }

  onMounted(()=>{
    if(route.query){
      data.type = route.query.type
      data.sendGoodsNo = route.query.sendGoodsNo
      data.mtlNo = route.query.mtlNo
      data.goodsSort = route.query.goodsSort
      data.uuidFail = route.query.uuidFail
      data.checkTime = route.query.checkTime
      data.source = route.query.source
    }
    if(data.type === 'VMI'){
      searchTestRecordCheckVMI()
    }else{
      searchTestRecordCheck()
    }
    if(sczRef.value){
      data.oneWeight = (sczRef.value.offsetWidth - 12) * 0.13 / 8 - 1.5
      data.imageWeight = sczRef.value.offsetWidth * 0.85
    }
  })

</script>

<style lang=scss>
.dialog_style {
  .haier-dialog {
    top: 5%;
    .lookImg_style{
      height: calc(100vh - 280px);
      width: 100%;
      object-fit:contain;
    }
  }
}
.intoFactoryUnqualifiedDetailPage_style{
  .code_number_style{
    font-weight: 600;
    word-break: break-all;
    display: -webkit-box; /* 设置为WebKit内核的弹性盒子模型 */
    -webkit-box-orient: vertical; /* 垂直排列 */
    -webkit-line-clamp: 2; /* 限制显示两行 */
    overflow: hidden; /* 隐藏超出范围的内容 */
    text-overflow: ellipsis; /* 使用省略号 */
  }
  .redTitle_style{
    td{
      color: red;
      span{
        color: red;
      }
    }
  }
  .wrap_style{
    background-color: #fff;
    .table-box {
      overflow: auto;
      border-top: 1px solid #ccc;
      border-left: 1px solid #ccc;
      margin: 0px 10px 10px 10px;
    }
    .table-box table a:link {
      color: blue;
    }
    .table-box table a:visited {
      color: blue;
    }
    .table-box table {
      border-collapse: collapse;
      width: 100%;
    }
    .table-box tbody{
      max-height: 200px;
      overflow-y: scroll;
      .big_input_style{
        border: 1px solid #ccc;
        background-color: #F1F2F8;
        color:#1d2129;
        border-radius: 2px;
        box-sizing: border-box;
      }
      .small_input_style{
        min-width: 24px;
        min-width: calc(var(--oneWeight)*1px);
        float: left;
        border: 1px solid #ccc;
        background-color: #F1F2F8;
        color:#1d2129;
        border-radius: 2px;
        box-sizing: border-box;
        height: 27px;
      }
      .noPadding_style{
        padding-left: 0px !important;
      }
    }
    .table-box table th,
    .table-box table td {
      font-size: 14px;
      text-align: center;
      line-height: 25px;
      padding: 2px 1px 2px 5px;
    }
    .table-middle{
      table-layout: fixed;
      width: 100%;
    }
  
    #testStandardBox td {
      text-align: left;
    }
    .table-box table th {
      font-size: 14px;
      color: black;
      line-height: 25px;
  
    }
    .table-box table thead tr {
      background: #fff;
      line-height: 25px;
    }
    .table-box table tbody tr {
      color: #666;
      border-top: 1px solid #ccc;
      height: 35px;
      line-height: 25px;
    }
    .column-1{
    border-collapse: collapse;
    background-clip: padding-box;
    position: sticky;
    left : -1px;
    border-left: 0px #fff solid;
    background-image: linear-gradient(to right ,#fff 99%, #ccc);
    z-index: 10;
  }
  .column-2{
    background-clip: padding-box;
    border-collapse: collapse;
    border-spacing: 0;
    position: sticky;
    left : 38px;
    border-left: 0px #fff solid;
    background-image: linear-gradient(to right ,#ccc,#fff 1%,#fff 99%, #ccc);
    z-index: 10;
  }
  .column-3{
    border-collapse: collapse;
    background-clip: padding-box;
    position: sticky;
    left : 138px;
    border-left: 0px #fff solid;
    background-image: linear-gradient(to right ,#ccc,#fff 1%,#fff 99%, #ccc);
    z-index: 10;
  }
  .text-overflow {
    word-break:keep-all;/* 不换行 */
    white-space:nowrap;/* 不换行 */
    overflow:hidden;/* 内容超出宽度时隐藏超出部分的内容 */
    text-overflow:ellipsis;/* 当对象内文本溢出时显示省略标记(...) ；需与overflow:hidden;一起使用。*/
  }
  .text-overflow:hover {
    word-break:break-all;
    white-space:pre-line;
    text-overflow: inherit;
    overflow: visible;
  }
    .table-box table tbody tr :nth-child(2) {
      max-width:80px;
    }
    .el-input {
      background-color: #f2f2f2;
    }
    /*加边框*/
    .table-bordered,
    .table-bordered table,
    .table-bordered th,
    .table-bordered td {
      border: 1px solid #ccc;
    }
    .table-box-bordered th {
      border-right: 1px solid #ccc;
      border-bottom: 1px solid #ccc;
    }
    .table-box-bordered td {
      border-right: 1px solid #ccc;
      border-bottom: 1px solid #ccc;
    }
  }
  


  .default-body-image-list {
    display: flex;

    .default-body-image {
      margin: 10px;
      .image_text_style{
        display: flex;
        flex-flow: column;
        cursor: pointer;
        color: #6a6a6a;
        width: 100%;
        .default-body-image-icon {
          width: 72px;
          height: 72px;
          flex: none;
          border-radius: 5%;
        }
        .default-body-image-name {
          width: 100px;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
          color: #165dff;
        }
        .default-body-image-name:hover {
          width: 100px;
          white-space: normal;
          text-overflow: ellipsis;
          color: #165dff;
          word-break: break-all;
          overflow: unset;
        }
      }
    }
  }


  .default-body-image:hover {
    color: #2681ff;
  }
  .default-body-image-list::-webkit-scrollbar {
    background-color: transparent;
    width: 8px;

  }

  .default-body-image-list::-webkit-scrollbar-thumb {
    border-radius: 10px;
    background: rgba(0, 0, 0, 0.1);
    -webkit-box-shadow: #000;
  }
  .file_td_style{

    .file_content_style{
      display: flex;
      flex-flow: row;
      justify-content: flex-start;;
      width: calc(var(--imageWeight)*1px);
      span{
        color: #165dff; 
        cursor: pointer;
        display: block;
        width: calc(var(--imageWeight)*1px);
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        border-right: #ccc 1px solid;
        padding-left: 10px;
        padding-right: 5px;
      }
      span:hover {
        white-space: normal;
        text-overflow: ellipsis;
        color: #165dff;
        word-break: break-all;
        overflow: unset;
      }
      span:nth-child(2){
        max-width: calc(var(--imageWeight)*1px) !important;
      }
      span:last-child{
        border-right:0;
        padding-right: 0;
      }
      span:first-child{
        margin-left: 10px;
        padding-left: 0px;
      }
    }
  }
  .table-box2{
    border-top: 0 !important;
    border-left: 0 !important;
    td:first-child{
      border-left: 1px solid #ccc;
    }
  }
  .noBorder_tr_style{
    border: 0 !important;
    .noBorder_td_style{
      border:0 !important;
    }
  }
}
</style>